// Not in the NHS DS — secondary buttons in a grid, grouped by day in MpfDetails.

export interface MpfSlot {
  slotId: string;
  /** ISO datetime; the label is formatted client-side. */
  startsAt: string;
}

export interface MpfSlotDay {
  /** ISO date; the heading is formatted client-side. */
  date: string;
  slots: MpfSlot[];
}

export interface MpfSlotWeek {
  /** ISO date. */
  weekStartDate: string;
  days: MpfSlotDay[];
}

export interface MpfSlotPickerProps {
  weeks: MpfSlotWeek[];
  selectedSlotId?: string | null;
  emptyWeekMessage?: string;
  loading?: boolean;
}

// Defaults MUST be values (NOT factories) when using withDefaults
export const mpfSlotPickerDefaults = {
  selectedSlotId: null,
  emptyWeekMessage: 'No appointments available for online booking.',
  loading: false,
} satisfies Partial<MpfSlotPickerProps>;

export type MpfSlotPickerEmits = {
  (e: 'select', slotId: string): void;
};
